import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { OptionsService } from '../services/options.service'
import { setTriggerUtilizedOptions } from '../store/options.actions'

export function* getTriggerUtilizedOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const triggerUtilizedOptionsResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getTriggerUtilizedOptions,
    ])
    const { entity } = triggerUtilizedOptionsResponse
    if (entity) yield put(setTriggerUtilizedOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getTriggerUtilizedOptions() error: ${e}`))
  }
}

export function* getTriggerUtilizedOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getTriggerUtilizedOptions)
}
